import { ChangeDetectionStrategy, Component, Inject, inject, LOCALE_ID, signal, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { SuiviService } from '../../service/suivi-service';
import { Assurance } from '../../../shared/model';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { ToastrService } from '../../../shared/services/toastr-service';
import { MatToolbar } from "@angular/material/toolbar";
import { DatePipe } from '@angular/common';
import {  MatFormFieldModule } from "@angular/material/form-field";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { ReactiveFormsModule } from "@angular/forms";
import { AuthService } from '../../../auth/services/auth-service';
import { MatDialog } from '@angular/material/dialog';
import { ExportComponent } from '../../../shared/components/export-component/export-component';

@Component({
  selector: 'app-rapport-suivi-component',
  imports: [
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatProgressSpinner,
    SearchBarComponent,
    MatIcon,
    MatButtonModule,
    MatCheckboxModule,
    MatToolbar,
    MatDatepickerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    DatePipe
],
  templateUrl: './rapport-suivi-component.html',
  styleUrl: './rapport-suivi-component.css',
})
export class RapportSuiviComponent {
  displayedColumns: string[] = ['assure', 'categorie', 'puissance_en', 'dta', 'attestation', 'carte_rose', 'effet', 'fin', 'compagnie', 'produit_le', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();

  originData : any[] = []

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  loading = signal(false)

  rapportData : Assurance[] = []

  authService = inject(AuthService)
  readonly dialog = inject(MatDialog);


  constructor(
    private suiviService : SuiviService,
    private sweetService : SweetAlertService,
    private toastr : ToastrService,
  ){

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.loadRapports()
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
  }

  applyFilter(event : string){
    this.selection.clear();
    this.rapportData.splice(0, this.rapportData.length)
    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

  loadRapports(){
    this.loading.update(val => true)
    this.suiviService.assurances().subscribe({
      next : (res) =>{
        this.loading.update(val => false)
        this.dataSource.data = res.slice()
        this.originData = res.slice()
      },
      error : (err) =>{
        this.loading.update(val => false)
      }
    })
  }

   selection = new SelectionModel<Assurance>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.rapportData = []
      return;
    }

    this.selection.select(...this.dataSource.filteredData);
    this.rapportData = this.dataSource.filteredData.slice()
  }

  selectAssurance(row : Assurance){
    if(this.rapportData.findIndex(item => item.id == row.id) == -1 && this.selection.isSelected(row)){
      this.rapportData.push(row)
    }else{
      this.rapportData.splice(this.rapportData.findIndex(item => item.id == row.id), 1)
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Assurance): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return ``;
  }

  saveRapport(){
    this.sweetService.confirm('Voulez-vous vraiment envoyer ce rapport ?')
    .then((res) =>{
      if(res.isConfirmed){

        this.suiviService.transmission(this.rapportData).subscribe({
          next : (res) =>{
            this.loadRapports()
            this.selection.clear();
            this.rapportData.splice(0, this.rapportData.length)
          },
          error : (err) =>{
            this.toastr.error("Une erreur est survenue")
          }
        });
      }
    })

  }

  openExportModal(){
    this.dialog.open(ExportComponent, {
      width: '500px',
      data : 'export-rapport-suivi'
    })
  }

}


